var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    {
      staticClass: "app-nav navbar mortgage-application-navbar",
      attrs: { id: "client-app-nav" },
    },
    [
      _c(
        "b-row",
        { staticClass: "w-100" },
        [
          _vm.showLogo
            ? _c(
                "b-col",
                {
                  staticClass:
                    "px-3 d-flex align-items-center justify-content-center",
                  attrs: { cols: "2", md: "auto" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "logo" },
                    [
                      _c("router-link", { attrs: { to: "/login" } }, [
                        _c("img", {
                          staticClass: "logo-img",
                          attrs: {
                            alt: _vm.$t("global.words.filogixLogo"),
                            src: _vm.$options.filters.getLogo(),
                          },
                        }),
                      ]),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "steps my-auto", attrs: { cols: "12", md: "" } },
            [
              _c(
                "b-row",
                {
                  staticClass:
                    "justify-content-md-start align-items-center step-bar flex-nowrap",
                },
                [
                  _vm.showControls
                    ? _c(
                        "b-col",
                        {
                          staticClass:
                            "step d-flex justify-content-center align-items-start flex-column col-auto step-controls d-md-none",
                          class: {
                            completed: _vm.isPreviousItemCompleted,
                            clickable: _vm.isPreviousItemCompleted,
                          },
                          attrs: { lg: "" },
                          on: {
                            click: function ($event) {
                              return _vm.handlePreviousStepClick()
                            },
                          },
                        },
                        [
                          _c("p", { staticClass: "step-count" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("global.words.prev")) +
                                "\n          "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass:
                                "step-title step-title-inline-icon d-flex flex-row flex-nowrap align-items-center text-center text-truncate",
                            },
                            [
                              _c("i", {
                                staticClass: "fa fa-arrow-left",
                                attrs: { "aria-hidden": "true" },
                              }),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.pages, function (page, index) {
                    return _c(
                      "b-col",
                      {
                        key: index,
                        staticClass:
                          "step d-flex justify-content-center align-items-center flex-column",
                        class: {
                          completed: _vm.isCompleted(page),
                          clickable:
                            _vm.isCompleted(page) ||
                            _vm.allPreviousCompleted(page, index),
                          navigatable:
                            _vm.isCompleted(page) ||
                            _vm.allPreviousCompleted(page, index),
                          current: page.key === _vm.current,
                          selected: page.key === _vm.current,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleClick(page, index)
                          },
                        },
                      },
                      [
                        _c("p", { staticClass: "step-count" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t("global.words.stepNumber", {
                                  stepNumber: index + 1,
                                })
                              ) +
                              "\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticClass:
                              "step-title step-title-inline-icon d-flex flex-row flex-nowrap align-items-center text-center",
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(page.label) +
                                "\n            "
                            ),
                            _c("i", {
                              staticClass:
                                "fa fa-check d-none step-title-icon ml-1",
                              attrs: { "aria-hidden": "true" },
                            }),
                          ]
                        ),
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _vm.showControls
                    ? _c(
                        "b-col",
                        {
                          staticClass:
                            "step d-flex justify-content-center align-items-center flex-column step-controls d-md-none",
                          class: {
                            completed: _vm.isNextItemCompleted,
                            clickable: _vm.isNextItemCompleted,
                          },
                          attrs: { cols: "auto", lg: "" },
                          on: {
                            click: function ($event) {
                              return _vm.handleNextStepClick()
                            },
                          },
                        },
                        [
                          _c("p", { staticClass: "step-count" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("global.words.next")) +
                                "\n          "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass:
                                "step-title step-title-inline-icon d-flex flex-row flex-nowrap align-items-center text-center",
                            },
                            [
                              _c("i", {
                                staticClass: "fa fa-arrow-right",
                                attrs: { "aria-hidden": "true" },
                              }),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "mt-2 px-0 app-progress-bar-wrapper",
                  attrs: { cols: "12" },
                },
                [
                  _c("div", { staticClass: "progress-bar" }, [
                    _c("div", {
                      staticClass: "fill-bar",
                      style: {
                        transition: "all 1s ease-in-out",
                        transform: "translateX(-" + _vm.currentPercent + "%)",
                      },
                    }),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }